import React, { useEffect } from "react";
import { Button, LogoHp, Card } from "@veneer/core";
import LoginConstants from "./LoginConstants";


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
const Login = () => {
    useEffect(() => {
        const storedToken = getCookie('auth-token');
        if (storedToken) {
            // Redirect to the stored URL if token exists
            const redirectURL = localStorage.getItem('redirectURL');
            if (redirectURL) {
                window.location.href = redirectURL;
            } else {
                window.location.href = '/';
            }
        }
    }, []);

    const handleSignIn = () => {
        const authUrl =
            `${process.env.REACT_APP_PHPSC_FRONT_AUTH_URI}?response_type=code&` +
            `client_id=${process.env.REACT_APP_PHPSC_FRONT_CLIENT_ID}&` +
            `redirect_uri=${process.env.REACT_APP_PHPSC_FRONT_REDIRECT_URI}&` +
            `scope=${LoginConstants.scope}`;

        window.location.replace(authUrl); // Redirect the user to the authentication URL
    };

    return (
        <div className="container-fluid">
            <div className="card-wrapper">
                <Card
                    appearance="dropShadow"
                    className="p-5 card-content"
                    content={
                        <React.Fragment>
                            <div className="mt-5">
                                <Button
                                    onClick={handleSignIn}
                                    appearance="secondary"
                                    leadingIcon={<LogoHp />}
                                >
                                    {LoginConstants.login}
                                </Button>
                            </div>
                        </React.Fragment>
                    }
                />
            </div>
        </div>
    );
}

export default Login;
